




















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import moment from "moment";
@Component({})
export default class DatePickerComponent extends Vue {
  @Prop() public placeholder: any;
  @Prop() public value: any;
  @Prop() public maxDate: any;
  @Prop() public minDate: any;
  @Prop() public disabled: any;
  @Prop() public position: any;
  @Prop() public particularFormat: any;
  @Prop() public yearsRange: any;
  @Prop() public type: any;
  private fechaSelected: any = null;
  //max_date = this.maxDate || null;
  //min_date = this.minDate || null;
  //years_range = this.yearsRange || [-35, 35];
  
  get minDateFormatted() {
    if (this.minDate) {
      let exactMinDate = this.minDate.setHours(0,0,0,0);
      return new Date(exactMinDate);
    }
    return this.minDate;
  }


  private months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  private days = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];

  dateFormat(dt: any) {
    if (dt) {
      if (this.particularFormat)
        return moment(dt).format(this.particularFormat);
      else return moment(dt).format("LL");
    }
  }

  @Watch("fechaSelected", { immediate: true })
  onFechaSelectedChange() {
    // if (this.fechaSelected) {
    //   this.fechaSelected.setHours(new Date().getHours());
    // }
    this.$emit("input", this.fechaSelected);
    this.$emit("onFechaChange", this.fechaSelected);
  }

  @Watch("value", { immediate: true })
  onValueChange() {
    if (this.value == null) this.fechaSelected = null;
    else this.fechaSelected = this.value;
  }
}
